
import React from "react";
import LegalLayout from "@/components/layout/LegalLayout";
import { FileText } from "lucide-react";

const CookiePolicy = () => {
  return (
    <LegalLayout 
      title="Cookie Policy" 
      icon={<FileText className="h-5 w-5 text-primary" />}
      lastUpdated="July 22, 2025"
    >
      <div className="space-y-4 text-sm text-slate-700 mb-6 p-4 bg-slate-50 rounded-lg">
        <p><strong>Effective Date:</strong> July 22, 2025</p>
        <p><strong>Operator:</strong> Timesy B.V., Raamplein 1, 1016 XK Amsterdam</p>
      </div>

      <h2>1. What Are Cookies?</h2>
      <p>
        Cookies are small text files stored on your device that help us improve your experience on SnapRefund.
      </p>
      
      <h2>2. Types of Cookies We Use</h2>
      <ul>
        <li><strong>Essential Cookies:</strong> Required for basic functionality</li>
        <li><strong>Analytics Cookies:</strong> To understand how users interact with the site (e.g., via Google Analytics)</li>
        <li><strong>Functional Cookies:</strong> To remember preferences and enhance usability</li>
        <li><strong>Marketing Cookies:</strong> For personalized advertising and tracking</li>
      </ul>
      
      <h2>3. Consent</h2>
      <p>
        On your first visit, we request your consent for non-essential cookies via a cookie banner.
      </p>
      <p>
        You can adjust your cookie preferences at any time via your browser settings.
      </p>
      
      <h2>4. Third-Party Cookies</h2>
      <p>
        We may allow third parties (e.g., analytics providers or payment partners) to place cookies.
      </p>
      
      <h2>5. Your Rights</h2>
      <p>
        You may delete or block cookies using your browser settings, although some features may not work properly.
      </p>
      
      <h2>6. Contact</h2>
      <p>
        If you have any questions, contact: contact@snaprefund.com
      </p>
    </LegalLayout>
  );
};

export default CookiePolicy;
